export const ASSIGN_FIRMWARE_OPEN_MODAL = "ASSIGN_FIRMWARE_OPEN_MODAL";
export const ASSIGN_FIRMWARE_CLOSE_MODAL = "ASSIGN_FIRMWARE_CLOSE_MODAL";
export const ASSIGN_FIRMWARE_GET_DEVICE_REQUEST = "ASSIGN_FIRMWARE_GET_DEVICE_REQUEST";
export const ASSIGN_FIRMWARE_GET_DEVICE_RESULT = "ASSIGN_FIRMWARE_GET_DEVICE_RESULT";
export const ASSIGN_FIRMWARE_SET_DEVICE = "ASSIGN_FIRMWARE_SET_DEVICE";
export const ASSIGN_FIRMWARE_SEARCH_REQUEST = "ASSIGN_FIRMWARE_SEARCH_REQUEST";
export const ASSIGN_FIRMWARE_SEARCH_RESULT = "ASSIGN_FIRMWARE_SEARCH_RESULT";
export const ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT = "ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT";
export const ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT_RESULT = "ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT_RESULT";
export const ASSIGN_FIRMWARE_REQUEST = "ASSIGN_FIRMWARE_REQUEST";
export const ASSIGN_FIRMWARE_RESULT = "ASSIGN_FIRMWARE_RESULT";
export const ASSIGN_BULK_FIRMWARE_REQUEST = "ASSIGN_BULK_FIRMWARE_REQUEST";
export const ASSIGN_BULK_FIRMWARE_RESULT = "ASSIGN_BULK_FIRMWARE_RESULT";